import useEffectLoggedChange from './use-effect-logged-change.ts';

export default function useEffects(): void {
  useEffectLoggedChange();
}
